import { API_BASE, authFetch, readJson } from "./base";
import type { AssistantContextProjection } from "./projection-types";

export async function getAssistantContextProjection(): Promise<AssistantContextProjection> {
  const response = await authFetch(`${API_BASE}/projections/assistant-context`);
  return readJson<AssistantContextProjection>(
    response,
    "Failed to load assistant context"
  );
}

export { sendChat, checkHealth, executeAction } from "../api";
export type { ChatMessage, NextAction } from "../api";
